import * as React from "react";
import Link from "next/link";
import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { Icon } from "@nju/icons";
import { salesRoutes } from "@nju/routes";
import {
  A,
  BlockContent,
  Button,
  Modal,
  Separator,
  Text,
  useOverlay,
} from "@nju/ui";
import { CancelOrderModal } from "../../cancelOrder";

export function MnpImpossiblePage() {
  const multiOrder = useOrchestrators("multiOrder");
  const cancelOrderModal = useOverlay();

  const { id } = multiOrder;

  return (
    <BlockContent grid="narrow">
      <Separator size="m" tone="invisible" />
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          przeniesienie numeru nie jest możliwe
        </Text>
        <Separator size="s" tone="invisible" />
        <div className="flex justify-center">
          <Icon
            className="w-[90px] h-[90px] only-mobile:scale-90"
            name="hand-incircle-fail"
          />
        </div>
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          className="max-w-[630px]"
          size={{ "@onlyMobile": "l", "@fromTablet": "xl" }}
          weight="bold"
        >
          Weryfikacja tożsamości w toku
        </Text>
        <Separator size="xxs" tone="invisible" />
        <Text align="center" size={{ "@onlyMobile": "m", "@fromTablet": "l" }}>
          Klient zamówił usługę nju światłowód i jego tożsamość zostanie
          potwierdzona
          <Separator size="none" tone="invisible" />
          przez Technika podczas instalacji.
        </Text>
      </div>
      <Separator size="xl" />
      <div className="gap-4 flex only-mobile:flex-col-reverse from-tablet:flex-row justify-center">
        <Button
          onPress={cancelOrderModal.open}
          size={{
            "@onlyMobile": "s",
          }}
          variant="secondary"
        >
          anuluj zamówienie
        </Button>
        <Link
          href={salesRoutes.idziemyDalej.get({
            screenVariant: "failed",
          })}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="primary"
          >
            przejdź dalej
          </A>
        </Link>
      </div>
      {cancelOrderModal.isOpened && (
        <Modal onClose={cancelOrderModal.close} title="anulowanie zamówienia">
          <CancelOrderModal
            mode="mobile"
            onClose={cancelOrderModal.close}
            orchestratorId={id}
          />
        </Modal>
      )}
      <Separator size="m" tone="invisible" />
    </BlockContent>
  );
}
